import { gql } from 'apollo-boost';

export const GET_BOOK_TYPE_QUERY = gql`
query pack($bookTemplateCategoryId: ID!) {
    bookTemplateCategory(bookTemplateCategoryId: $bookTemplateCategoryId) {
        id
        description
        name
        backgroundColor
        textColor
        iconUrl
        hidden
        parentId
        subcategories {
            id
            name
            backgroundColor
            textColor
            iconUrl
            description
            hidden
        }
        # isSingleChapter
        bookTemplates {
            id
            name
        }
    }
}
`;

export const ADD_BOOK_TYPE_MUTATION = gql`
mutation addBookTemplateCategory($name: String!, $description: String!, $iconUrl: String, $backgroundColor: String, $textColor: String) {
    addBookTemplateCategory(name: $name, description: $description, iconUrl:$iconUrl, backgroundColor:$backgroundColor, textColor:$textColor) {
        bookTemplateCategory {
            id
            name
            description
            iconUrl
            backgroundColor
            textColor
            bookTemplates {
                id
                name
                chapters {
                    id
                    title
                }
            }
        }
        errors
    }
}
`;

export const DELETE_BOOK_MUTATION = gql`
mutation deleteBookTemplate($bookTemplateId: ID!) {
    deleteBookTemplate(bookTemplateId: $bookTemplateId) {
        deleted
        errors
    }
}
`;


export const EDIT_BOOK_TYPE_MUTATION = gql`
mutation editBookTemplateCategory($bookTemplateCategoryId: ID!, $name: String!, $description: String!, $iconUrl: String, $backgroundColor: String, $textColor: String) {
    editBookTemplateCategory(bookTemplateCategoryId: $bookTemplateCategoryId, name: $name, description: $description, iconUrl:$iconUrl, backgroundColor:$backgroundColor, textColor:$textColor) {
        bookTemplateCategory {
            id
            name
            description
            iconUrl
            backgroundColor
            textColor
            bookTemplates {
                id
                name
                chapters {
                    id
                    title
                }
            }
        }
        errors
    }
}
`;